module.exports = __webpack_public_path__ + "img/liebelt-sw.2c037981.jpg";